import { __assign, __rest } from "tslib";
import React from 'react';
import { useQRCode } from './use-qrcode';
export var QRCode = function (_a) {
    var color = _a.color, errorCorrectionLevel = _a.errorCorrectionLevel, margin = _a.margin, maskPattern = _a.maskPattern, quality = _a.quality, scale = _a.scale, toSJISFunc = _a.toSJISFunc, type = _a.type, value = _a.value, version = _a.version, width = _a.width, props = __rest(_a, ["color", "errorCorrectionLevel", "margin", "maskPattern", "quality", "scale", "toSJISFunc", "type", "value", "version", "width"]);
    return React.createElement('img', __assign(__assign({}, props), { src: useQRCode({
            color: color,
            errorCorrectionLevel: errorCorrectionLevel,
            margin: margin,
            maskPattern: maskPattern,
            quality: quality,
            scale: scale,
            toSJISFunc: toSJISFunc,
            type: type,
            value: value,
            version: version,
            width: width,
        }) }));
};
//# sourceMappingURL=qrcode.js.map